/**
 * Usage:
 *
 * @${mediaMax.sm} {}
 *
 */
import { screenSizes } from '../tokens';
export const customMediaMaxQuery = (maxWidth) => `@media (max-width: ${maxWidth}px)`;
export const customMediaMinQuery = (maxWidth) => `@media (min-width: ${maxWidth}px)`;
const createMediaMap = (createMediaFn) => Object.keys(screenSizes).reduce((acc, label) => ({
    ...acc,
    [label]: createMediaFn(screenSizes[label]),
}), {});
export const mediaMaxWidth = createMediaMap(customMediaMaxQuery);
export const mediaMinWidth = createMediaMap(customMediaMinQuery);
//# sourceMappingURL=index.js.map